/*
xs, extra-small: 0px
sm, small: 600px
md, medium: 900px
lg, large: 1200px
xl, extra-large: 1536px

xs={10} sm={8} md={6} lg={4} xl={2}
*/

import { createTheme } from "@mui/material"
import { ptBR } from '@mui/material/locale'

/*
. Cores principais da marca
Puxando da logo (tons de azul e cinza):

Primary (principal): #4054B2

Primary Dark: #25326F (para cabeçalho, hover, textos importantes)

Primary Light: #6576D4 (para destaques, ícones, bordas)

Neutral Dark (cinza logo): #50545A

Neutral Medium: #8A9099 (textos secundários, bordas)

Neutral Light: #E2E7EE (fundos de cards, inputs)

2. Cores de feedback (como você pediu)
Mantendo as suas e só organizando nomes:

Warning: #F5A623
Error: #E04B3D
Info: #041E2A
Success: #2BBE7B
Sugestão de versões suaves para fundos de alertas:

Warning Background: #FFF3D6
Error Background: #FCE1DE
Info Background: #E0E7EF
Success Background: #D8F4E7
3. Texto, fundo e elementos de interface
Usando as que você já definiu e ajustando algumas auxiliares:

Background Principal (corFundo): #C7D3DD
Background Alternativo (cards / seções): #F4F6F9
Título (corTitulo): #041E2A
Texto padrão / mensagem (corMensagem): #041E2A
Texto secundário: #50545A
Bordas suaves / linhas: #D0D6E0
4. Estados de componentes
Primary Button:

Fundo: #4054B2
Hover: #25326F
Texto: #FFFFFF
Secondary Button (borda):

Borda: #4054B2
Texto: #4054B2
Hover: fundo #E0E5F7
Disabled:

Fundo: #E2E7EE
Texto: #8A9099



*/

export const THEME = createTheme({
  components: {
    MuiIconButton: {
      defaultProps: {
        color: 'primary',
        style: { height: '35px', width: '35px' }
      }
    }
  },
  /*
  components: {
    MuiIcon: {
      styleOverrides: {
        root: {
          // Match 24px = 3 * 2 + 1.125 * 16
          boxSizing: 'content-box',
          padding: 5,
          fontSize: '1.125rem',
        },
      },
    },
  },
  */
  inputs: {
    marginTop: 2
  },
  menu: {
    corIcone: '#25326F',
    corIconeExcluir: '#041E2A',
    tamanhoIcone: 40
  },
  mensagens: {
    corWarning: '#F5A623',    // amarelo-alaranjado de alerta (bom contraste no fundo escuro)
    corError: '#E04B3D',    // vermelho/laranja forte para erro
    corInfo: '#041E2A',    // azul médio, em harmonia com o principal
    corSuccess: '#2BBE7B',    // verde moderno, destaca bem no azul escuro

    corFundo: '#D0D6E0',    // variação ainda mais escura da principal para background geral
    corTitulo: '#041E2A',    // quase branco para títulos (boa legibilidade no fundo escuro)
    corMensagem: '#50545A',    // cinza-azulado claro para textos normais

    tamanhoIcone: 50
  },
  palette: {
    primary: {
      main: '#4054B2'

    },
    secondary: {
      main: '#6576D4'
    }
  }
}, ptBR);

declare module '@mui/material/styles' {
  interface Theme {
    menu: {
      corIcone: string
      corIconeExcluir: string
      tamanhoIcone: number
    }
    inputs: {
      marginTop: number
    }
    mensagens: {
      corWarning: string
      corError: string
      corInfo: string
      corSuccess: string
      corFundo: string
      corTitulo: string
      corMensagem: string
      tamanhoIcone: number
    }
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    inputs: {
      marginTop: number
    }
    menu: {
      corIcone: string
      corIconeExcluir: string
      tamanhoIcone: number
    },
    mensagens: {
      corWarning: string
      corError: string
      corInfo: string
      corSuccess: string
      corFundo: string
      corTitulo: string
      corMensagem: string
      tamanhoIcone: number
    }
  }
}
